/**
 * Her mark (spec §5): a stroked spiral of about two turns with a short
 * thread tail, derived from ꩜. Pure geometry in board units, centred on the
 * node it sits on; `r` is that node's radius.
 */
export const MARK_TURNS = 2;
const BODY = 0.85;
const TAIL: [number, number] = [0.9, 0.35];

export function spiralPoints(
  r: number,
  turns = MARK_TURNS,
  steps = 48,
): [number, number][] {
  const pts: [number, number][] = [];
  const maxA = turns * 2 * Math.PI;
  for (let i = 0; i <= steps; i++) {
    const a = (i / steps) * maxA;
    const rad = r * BODY * (a / maxA);
    pts.push([rad * Math.cos(a), rad * Math.sin(a)]);
  }
  const [lx, ly] = pts[pts.length - 1];
  pts.push([lx + r * TAIL[0], ly + r * TAIL[1]]);
  return pts;
}

export function spiralPath(r: number): string {
  return spiralPoints(r)
    .map(
      ([x, y], i) => `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`,
    )
    .join(" ");
}

export function pathLength(pts: readonly [number, number][]): number {
  let len = 0;
  for (let i = 1; i < pts.length; i++) {
    len += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
  }
  return len;
}
